import { ListItemIcon, ListItemText, MenuList, MenuItem } from "@mui/material"
import { AccountTree, Layers, Star, PlayCircle, Videocam, Movie, Handshake, SwitchAccount } from "@mui/icons-material"
import { Link, useMatch } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAuth } from "../auth"

type ItemProps = {
  icon: React.ReactNode
  text: string
  to: string
  matchPath?: string
  setIsOpen?: (isOpen: boolean) => void
}

function Item({ icon, text, to, matchPath, setIsOpen }: ItemProps) {
  const match = useMatch(matchPath ?? to.replace(/:[^/]+/g, "*"))
  return (
    <MenuItem
      title={text}
      component={Link}
      onClick={() => {
        if (setIsOpen) {
          setIsOpen(false)
        }
      }}
      to={to}
      selected={!!match}
      sx={{
        "&.Mui-selected": {
          backgroundColor: "primary.dark",
          color: "white",
        },
        "&.Mui-selected:hover": {
          backgroundColor: "primary.dark",
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: 40, color: "inherit" }}>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </MenuItem>
  )
}

export default function MenuMobile({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) {
  const { i18n, t } = useTranslation()
  const { user } = useAuth()
  const lang = i18n.language
  const canSeePrivateItems = user?.ruolo === "amministratore" || user?.is_superuser || user?.ruolo === "operatore"

  return (
    <div
      style={{
        display: !isOpen ? "none" : "block",
        position: "absolute",
        top: 58,
        left: 0,
        width: "100%",
        zIndex: 1000,
        backgroundColor: "white",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <MenuList sx={{ py: 0 }}>
        {canSeePrivateItems && (
          <Item icon={<Handshake />} text={t("pages.donatori")} to={`/${lang}/donatori`} setIsOpen={setIsOpen} />
        )}
        <Item
          icon={<SwitchAccount />}
          text={t("pages.produttori")}
          to={`/${lang}/produttori`}
          matchPath={`/${lang}/produttori/*`}
          setIsOpen={setIsOpen}
        />
        <Item
          icon={<Star />}
          text={t("pages.fondi")}
          to={`/${lang}/fondi`}
          matchPath={`/${lang}/fondi/*`}
          setIsOpen={setIsOpen}
        />
        <Item
          icon={<PlayCircle />}
          text={t("pages.documenti")}
          to={`/${lang}/documenti`}
          matchPath={`/${lang}/documenti/*`}
          setIsOpen={setIsOpen}
        />
        <Item
          icon={<Layers />}
          text={t("pages.supporti")}
          to={`/${lang}/supporti`}
          matchPath={`/${lang}/supporti/*`}
          setIsOpen={setIsOpen}
        />
        <Item
          icon={<Videocam />}
          text={t("pages.file_digitali")}
          to={`/${lang}/files`}
          matchPath={`/${lang}/files/*`}
          setIsOpen={setIsOpen}
        />
        <Item icon={<Movie />} text={t("pages.sequenze")} to={`/${lang}/sequenze`} setIsOpen={setIsOpen} />
        {canSeePrivateItems && (
          <Item
            icon={<AccountTree />}
            text={t("pages.assemblaggi")}
            to={`/${lang}/assemblaggi`}
            matchPath={`/${lang}/assemblaggi/*`}
            setIsOpen={setIsOpen}
          />
        )}
      </MenuList>
    </div>
  )
}
